import { v4 as uuidv4 } from 'uuid';

export function NewsletterInputEmail(props = {}, childrenComponents = []) {
	return {
		componentName: 'NewsletterInputEmail',
		componentId: uuidv4(),
		props: Object.assign(
			{
				blockClass: 'newsletter__input-email',
				placeholderText: 'Digite seu e-mail...',
				inputLabel: '',
			},
			props,
		),
		childrenComponents,
	};
}
